// TODO: Temporary solutions until the api is updated
// TODO: Needs to update API request, needs to add item size, search by segment name and gets segment list by segment id list
import { useState, useContext } from 'react';
import { message } from 'antd';
import { ProductAlertsContext } from '../../ProductAlertsProvider';
import useAsyncEffect from 'src/hooks/useAsyncEffect';
import { MonitoredSegment } from '../types/AlertConfiguration';
import { getMonitoredSegments } from '../../api/alertConfiguration.api';

type MonitoredSegmentsState = {
  loading: boolean;
  segmentList: MonitoredSegment.Item[];
  setSegmentName: (name: string) => void;
};

type PropsUseMonitoredSegments = {
  segmentIds: number[];
};

const LIMIT = 10;

export const useMonitoredSegments = ({ segmentIds }: PropsUseMonitoredSegments): MonitoredSegmentsState => {
  // TODO: context will not be used after updating API
  const { monitorableSegments, setMonitorableSegments } = useContext(ProductAlertsContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [segmentName, setSegmentName] = useState<string>('');
  const [segmentList, setSegmentList] = useState<MonitoredSegment.Item[]>([]);

  const setCombinedSegments = (monitoredSegments: MonitoredSegment.Item[], name: string) => {
    const selectedBefore = monitoredSegments.filter((el) => segmentIds.includes(el.productSegmentId));
    const nameUpperCase = name.toUpperCase();
    let filteredByName = monitoredSegments.filter((el) => el.productSegmentName.toUpperCase().includes(nameUpperCase));

    if (filteredByName.length > LIMIT) {
      filteredByName = filteredByName.slice(0, LIMIT);
    }

    filteredByName = filteredByName.filter((el) => !segmentIds.includes(el.productSegmentId));
    const combine = filteredByName.concat(selectedBefore);

    setSegmentList(combine);
  };

  useAsyncEffect(async () => {
    if (monitorableSegments.length === 0) {
      setLoading(true);
      try {
        const { segmentList } = await getMonitoredSegments();
        setCombinedSegments(segmentList, segmentName);
        setMonitorableSegments(segmentList);
      } catch (e) {
        message.error('There was an error while loading Monitored Segments.');
        console.error(e);
      }
      setLoading(false);
    } else {
      setCombinedSegments(monitorableSegments, segmentName);
    }
  }, [segmentName]);

  return { loading, segmentList, setSegmentName };
};
